import { render, staticRenderFns } from "./UnauthenticatedLayout.vue?vue&type=template&id=66d63a08&scoped=true&"
import script from "./UnauthenticatedLayout.vue?vue&type=script&lang=js&"
export * from "./UnauthenticatedLayout.vue?vue&type=script&lang=js&"
import style0 from "./UnauthenticatedLayout.vue?vue&type=style&index=0&id=66d63a08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d63a08",
  null
  
)

export default component.exports